import service from './service';

export default {
  // 查看我的企业资料
  getCompany() {
    return service.get('/api/v1/company');
  },
  //  企业认证
  patchAuthentication(certificateId) {
    return service({
      url: '/api/v1/company/authentication',
      method: 'patch',
      data: {
        certificate_id: certificateId
      }
    });
  },
  //  提交公司信息
  patchInfo() {
    return service.patch('/api/v1/company');
  },
  // 获取企业小分类（行业性质下的行业分类）
  getCategory(subareaId) {
    return service.get(`/api/v1/company/:${subareaId}/category`);
  },
  // 获取企业大分类(性质分类)
  getSubareaList() {
    return service.get('/api/v1/company/subarea/list');
  },
  // 企业注册
  postRegister() {
    return service.post('/api/v1/company/info');
  }
};



// WEBPACK FOOTER //
// ./src/api/enterprise-register.js